goog.provide("shadow.js.shim.module$$embedpdf$react$interaction");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$interaction");
shadow.js.shim.module$$embedpdf$react$interaction = shadow.js.nativeProvides["@embedpdf/react/interaction"] = shadow$bridge("@embedpdf/react/interaction");
module$shadow_js_shim_module$$embedpdf$react$interaction.default = shadow.js.shim.module$$embedpdf$react$interaction;
